<template>
  <!-- A date + time box (dd/MM/yyyy HH:mm) that can be typed, copied and pasted; the calendar icon opens the date picker -->
  <div class="dtf dp__theme_light">
    <div class="dp__input_wrap">
      <input :value="text" class="dp__input dp__input_icon_pad" :class="{ dp__input_invalid: bad }" placeholder="dd/mm/yyyy hh:mm" spellcheck="false" autocomplete="off"
        @input="typed($event.target.value)" @focus="focused = true; $event.target.select()" @blur="focused = false; text = show(modelValue); bad = false"
        @keydown.enter.prevent="typed($event.target.value)" />
    </div>
    <VueDatePicker class="dtf-cal" :model-value="modelValue" @update:model-value="(d) => d && emit('update:modelValue', d)" format="dd/MM/yyyy HH:mm" :clearable="false">
      <template #trigger>
        <button type="button" class="dtf-btn" title="Calendar"><v-icon icon="mdi-calendar-blank-outline" size="18"></v-icon></button>
      </template>
    </VueDatePicker>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';
import VueDatePicker from '@vuepic/vue-datepicker';

const props = defineProps({ modelValue: [Date, String, Number] });
const emit = defineEmits(['update:modelValue']);

const pad = (n) => String(n).padStart(2, '0');
const show = (v) => {
  const d = v ? new Date(v) : null;
  return d && !isNaN(d) ? `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}` : '';
};
// dd/MM/yyyy HH:mm (also - or . between the date parts; the time may be left off = 00:00), local time
const RE = /^\s*(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})(?:[\sT,]+(\d{1,2}):(\d{2}))?\s*$/;
const parse = (s) => {
  const m = RE.exec(String(s || ''));
  if (!m) return null;
  const [day, mon, year, h = 0, min = 0] = m.slice(1).map((x) => (x === undefined ? 0 : Number(x)));
  const d = new Date(year, mon - 1, day, h, min);
  return d.getDate() === day && d.getMonth() === mon - 1 && h < 24 && min < 60 ? d : null;
};

const text = ref(show(props.modelValue));
const bad = ref(false);
const focused = ref(false);
watch(() => props.modelValue, (v) => { if (!focused.value) text.value = show(v); });

const typed = (v) => {
  text.value = v;
  const d = parse(v);
  bad.value = !d;
  if (d) emit('update:modelValue', d);
};
</script>

<style scoped>
.dtf { position: relative; }
.dtf-cal { position: absolute !important; left: 0; top: 0; width: 36px; height: 40px; }
.dtf-btn { width: 36px; height: 40px; display: inline-flex; align-items: center; justify-content: center; color: var(--dp-icon-color, #959595); background: transparent; }
</style>
